import { Button, Card, Form, Input, Radio, notification } from "antd";
import Title from "atoms/Title";
import COLORS from "common/Colors";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { useMutate } from "hooks/useMutate";
import { useQueryState } from "hooks/useQueryState";
import React, { useState } from "react";
import {
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { useRouteState } from "hooks/useRouteState";
import styled from "styled-components";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useSelector } from "react-redux";
import { getUserList, getFilteredClientData } from "redux/selectors";

const labelStyle = {
  width: "80px",
  display: "inline-block",
  textAlign: "start",
};

const ClientSurvey = () => {
  const { id: engagementId } = useRouteState(["id"]);
  const [formStep, setFormStep] = React.useState(1);
  const [surveryId, setSurveyId] = React.useState(null);
  const userList = useSelector((state) => getUserList(state));

  const { getEngagementById, addClientSurvey: addClientSurveyQuery } =
    queryKeys;

  const { key, url } = getEngagementById(engagementId);

  const { key: addClientSurveyKey, url: addClientSurveyUrl } =
    addClientSurveyQuery(engagementId);

  const { isFetched } = useQueryState(key);

  const { data: engagementDataRes } = useFetch(key, url, {
    enabled: !isFetched,
  });

  const engagementData = engagementDataRes?.data;

  const { mutate: addClientSurvey } = useMutate(
    addClientSurveyKey,
    addClientSurveyUrl
  );

  const handleClientSurveyFirstForm = (values) => {
    const data = {
      surveyData: [
        {
          question: "1. Were the service timely?",
          answer: values.service_timely,
        },
        {
          question: "2. Were the staff responsive and knowledgeable?",
          answer: values.staff_responsive,
        },
        {
          question: "3. Did you get value for money from the service?",
          answer: values.value_for_money,
        },
        {
          question:
            "4. Would you continue using BDO and recommend them to a friend or colleague?",
          answer: values.recommend,
        },
        {
          question:
            "5. Was the methodology, technology and analysis used of high quality?",
          answer: values.quality,
        },
        {
          question: "6. Comment",
          answer: values.comment ?? "",
        },
      ],
    };

    addClientSurvey(data, {
      onSuccess: (res) => {
        notification.success({
          message: "Client Survey added successfully",
        });
        setSurveyId(res.surveyId);
        setFormStep(2);
      },
    });
  };
  const cursorStyle = { cursor: "pointer" }
  const history = useHistory();

  const breadStyle = { color: "#636980", cursor: "pointer" };
  const breadcrumbs = [
    <label key="2" style={breadStyle} onClick={() => history.goBack()}>
      {engagementData?.information?.jobTitle}
    </label>,
    <Typography key="3" color="text.primary">
      Client Satisfaction Survey
    </Typography>,
  ]

  return (
    <ClientSurveyWrap>
      <div className="title-row">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>

        <div className="client">
          Client: {engagementData?.client?.clientId || "-"}
        </div>
      </div>

      {/* {formStep === 1 && (
        <Form layout="vertical" onFinish={handleClientSurveyFirstForm}>
          <Card bordered={false}>
            <Form.Item
              label="1. Were the service timely?"
              name="service_timely"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Radio.Group optionType="button" buttonStyle="solid">
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="2. Were the staff responsive and knowledgeable?"
              name="staff_responsive"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Radio.Group optionType="button" buttonStyle="solid">
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="3. Did you get value for money from the service?"
              name="value_for_money"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Radio.Group optionType="button" buttonStyle="solid">
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="4. Would you continue using BDO and recommend them to a friend or colleague?"
              name="recommend"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Radio.Group optionType="button" buttonStyle="solid">
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="5. Was the methodology, technology and analysis used of high quality?"
              name="quality"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Radio.Group optionType="button" buttonStyle="solid">
                <Radio value={"yes"}>Yes</Radio>
                <Radio value={"no"}>No</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              label="6. Comment"
              name="comment"
              rules={[
                {
                  required: true,
                  message: "Please select an option",
                },
              ]}
            >
              <Input.TextArea
                rows={3}
                style={{
                  resize: "none",
                }}
              />
            </Form.Item>
          </Card>

          <div className="form-buttons">
            <Button type="primary" htmlType="submit">
              Next
            </Button>
          </div>
        </Form>
      )} */}

      {formStep === 1 && (
        <ClientSurveyEmailForm
          engagementId={engagementId}
          engagementData={engagementData}
          userList={userList}
        />
      )}
    </ClientSurveyWrap>
  );
};

export default ClientSurvey;

const ClientSurveyEmailForm = ({ engagementId, engagementData, userList }) => {
  const history = useHistory();
  const filteredClientList = useSelector((state) => getFilteredClientData(state));
  const { addClientSurveyEmail: addClientSurveyEmailQuery } = queryKeys;
  const { key: addClientSurveyEmailKey, url: addClientSurveyEmailUrl } =
    addClientSurveyEmailQuery(engagementId);

  const { mutate: addClientSurveyEmail, isLoading } = useMutate(
    addClientSurveyEmailKey,
    addClientSurveyEmailUrl
  );

  const emailaddress = (filteredClientList?.data?.[0]?.emailaddress1 !== null || filteredClientList?.response?.client?.emailaddress1 !== null) ? (filteredClientList?.data?.[0]?.emailaddress1 || filteredClientList?.response?.client?.emailaddress1) :
    (filteredClientList?.data?.[0]?.emailaddress2 !== null || filteredClientList?.response?.client?.emailaddress2 !== null) ? (filteredClientList?.data?.[0]?.emailaddress2 || filteredClientList?.response?.client?.emailaddress2) :
      (filteredClientList?.data?.[0]?.emailaddress3 !== null || filteredClientList?.response?.client?.emailaddress3 !== null) ? (filteredClientList?.data?.[0]?.emailaddress3 || filteredClientList?.response?.client?.emailaddress3) : "";

  const findUser = (id) => {
    return userList?.find((user) => user?.userid === id);
  };

  const assignedByPartner = findUser(engagementData?.stakeHolder?.partner);
  const assignedByPersonInCharge = findUser(engagementData?.stakeHolder?.personIncharge);
  const clientsurveylink = `https://www.uat.clientsurvey.bdo.insyts.co`;
  const managingpartnerName = assignedByPartner
    ? assignedByPartner?.firstname + " " + assignedByPartner?.lastname
    : null;
  const personInchargeName = assignedByPersonInCharge
    ? assignedByPersonInCharge?.firstname + " " + assignedByPersonInCharge?.lastname
    : null;

  const ccEmails = [
    engagementData?.stakeHolder?.partner,
    engagementData?.stakeHolder?.personIncharge // Add other emails as needed
  ].filter(Boolean).join(',');

  const initialValues = {
    title: engagementData?.information?.jobTitle,
    subject: "BDO would value your experience in our service – Client Survey",
    to: emailaddress,
    cc: ccEmails,
    body: `Dear ${engagementData?.client?.clientName},\n
    I hope this email finds you well.\n
    At BDO, we are committed to continuous improvement and value your feedback on the services we provide to your organization: ${engagementData?.client?.competency} / ${engagementData?.client?.serviceLine} – ${engagementData?.information?.jobTitle}.\n
    Included in this email is a link with a short survey to obtain your thoughts on the performance of the engagement team, which is led by the following:\n
    • ${engagementData?.stakeHolder?.partner}\n
    • ${engagementData?.stakeHolder?.personIncharge}\n
    The short survey form should take less than 3 minutes of your time using this link: ${clientsurveylink}\n
    We appreciate your prompt response to our request.\n
    Thank you for choosing BDO for your professional services needs. We are always striving to improve and deliver exceptional service to our clients.
    `,
    footer: `Regards,
${managingpartnerName},
Engagement Partner.`
  }
  const handleSubmit = (values) => {
    const data = {
      mailData: {
        title: values.title,
        subject: values.subject,
        toMail: values.to,
        ccMail: values.cc,
        body: values.body,
        footer: values.footer,
        clientsurveylink: clientsurveylink,
        managingpartnerName: managingpartnerName,
        managingpersoninchargeName: personInchargeName,
        engagementname: engagementData?.information?.jobTitle,
        clientId: engagementData?.clientId,
        clientname: engagementData?.client?.clientName,
        competency: engagementData?.client?.competency,
        serviceLine: engagementData?.client?.serviceLine,
      },
    };
    addClientSurveyEmail(data, {
      onSuccess: () => {
        notification.success({
          message: "Email sent successfully",
        });
        history.push("/engagement/view", { id: engagementId });
      },
    });
  };

  return (
    <Form onFinish={handleSubmit} layout="horizontal" initialValues={initialValues} colon={false}>
      <Card bordered={false}>
        <Form.Item label={<span style={labelStyle}>Title:</span>} name="title"
          rules={[{ required: true, message: 'Title is required' }]}
        >
          <Input placeholder="Enter" />
        </Form.Item>

        <Form.Item label={<span style={labelStyle}>Subject:</span>} name="subject"
          rules={[{ required: true, message: 'Subject is required' }]}
        >
          <Input placeholder="Enter" disabled />
        </Form.Item>

        <Form.Item label={<span style={labelStyle}>To:</span>} name="to"
          rules={[{ required: true, message: 'Recipient email is required' }]}
        >
          <Input disabled placeholder="Enter" />
        </Form.Item>

        <Form.Item label={<span style={labelStyle}>CC:</span>} name="cc">
          <Input placeholder="Enter" />
        </Form.Item>

        <Form.Item label={<span style={labelStyle}>Body:</span>} name="body"
          rules={[{ required: true, message: 'Body is required' }]}
        >
          <Input.TextArea
            rows={3}
            style={{
              resize: "none",
            }}
            disabled
          />
        </Form.Item>

        <Form.Item
          label={<span style={labelStyle}>Footer:</span>}
          name="footer"
          rules={[{ required: true, message: 'Footer is required' }]}
        >
          <Input.TextArea
            rows={3}
            style={{
              resize: "none",
            }}
            disabled
          />
        </Form.Item>
      </Card>

      <div className="form-buttons">
        <Button type="primary" htmlType="submit" loading={isLoading} disabled={engagementData?.clientsurveystatus}>
          Send Mail
        </Button>
        <Button
          type="primary"
          onClick={() => history.push("/engagement/view", { id: engagementId })}
        >
          Close
        </Button>
      </div>
    </Form>
  );
};

const ClientSurveyWrap = styled.div`
  .title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .client {
      font-size: 16px;
      color: #1b1b1b;
      font-weight: 600;
    }
  }
  label {
    color: #1b1b1b;
  }
  .form-buttons {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .ant-card-body {
    box-shadow: 0px 3px 6px #00000015;
  }
  .ant-radio-group {
    display: flex;
    align-items: center;
    gap: 20px;

    label.ant-radio-button-wrapper {
      width: 100px;
      text-align: center;
      background-color: #f7f7f8;
      &:hover {
        box-shadow: #00000015 0px 3px 6px;
      }
      .ant-radio-button-checked {
        background-color: ${COLORS.PRIMARY};
        color: black !important;
      }
      color: black !important;
      border: none;
    }

    .ant-radio-button-wrapper:not(:first-child)::before {
      display: none;
    }
  }
`;
